export enum OrderType {
  PICKUP = 'pickup',
  DELIVERY = 'delivery',
  TABLE = 'table'
}
